import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { DashboardDto } from "../../types/Dashboard";

const DashboardApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboard: builder.query<DashboardDto, void>({
            providesTags: [ResourceName.DASHBOARD],
            query: () => {
                const dataGroup = getAssignedDataGroup();

                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/dashboard`,
                    method: "GET",
                };
            },
        }),
    }),
});

export const { useGetDashboardQuery } = DashboardApi;
